import { portalEnv } from './config/portalEnv';

export const Configurl = {
  DefaultOrganizationLogo: portalEnv.defaultOrganizationLogo,
  OrganizationName: portalEnv.organizationName,
  apiBaseUrl: portalEnv.apiBaseUrl,
};

export default Configurl;
